import Vue from 'vue'
import Router from 'vue-router'


// import HelloWorld from '@/components/HelloWorld'


Vue.use(Router)
const main = resolve => require(['@/views/main.vue'], resolve)
// const login = resolve => require(['@/views/SafetyEducation/login.vue'], resolve)
// const home = resolve => require(['@/views/home/index.vue'], resolve)
// const zfw = resolve => require(['@/views/zfw/index.vue'], resolve)
//新客户端下载页
// const  down= resolve => require(['@/views/wxh5/down.vue'], resolve)
//完善信息页
const index = resolve => require(['@/views/zfw/index.vue'], resolve)
// const indexlist = resolve => require(['@/views/zfw/indexlist.vue'], resolve)
// // //首页
// const information = resolve => require(['@/views/zfw/information.vue'], resolve)
// const Answer = resolve => require(['@/views/zfw/Answer.vue'], resolve)
// // // 视频播放页
// const Fraction = resolve => require(['@/views/zfw/Fraction.vue'], resolve)
// // // 答题页
// const rankinglist = resolve => require(['@/views/zfw/rankinglist.vue'], resolve)
// // //往期课堂
// const fenx = resolve => require(['@/views/wxh5/fenx.vue'], resolve)
// // //搜索页
// const yqindex = resolve => require(['@/views/wxh5/yqindex.vue'], resolve)
// // //头像上传
// const yqnew = resolve => require(['@/views/wxh5/yqnew.vue'], resolve)
// // //设置页
// const yqpeople = resolve => require(['@/views/wxh5/yqpeople.vue'], resolve)
// const wxnewlist = resolve => require(['@/views/wxh5/wxnewlist.vue'], resolve)
// // //设置页
// const wxpeoplelist = resolve => require(['@/views/wxh5/wxpeoplelist.vue'], resolve)
// //安全知识详情
// const peoplelist1 = resolve => require(['@/views/zfw/peoplelist1.vue'], resolve)
// //答题分数
// const OK = resolve => require(['@/views/SafetyEducation/OK.vue'], resolve)
//新客户邀请页
// const  Invitation= resolve => require(['@/views/wxh5/Invitation.vue'], resolve)
//新客户端建设中
// const  Development= resolve => require(['@/views/newkhd/Development.vue'], resolve)
// // 拉新赚红包页
// const  redStatistics= resolve => require(['@/views/newCustomer/redStatistics.vue'], resolve)
// // 拉新我的奖励页
// const  myReward= resolve => require(['@/views/newCustomer/myReward.vue'], resolve)
// // 提现
// const  outMoney= resolve => require(['@/views/newCustomer/outMoney.vue'], resolve)
// // 排行榜
// const  rankingList= resolve => require(['@/views/newCustomer/rankingList.vue'], resolve)
// // 提现详情
// const  moneyDetails= resolve => require(['@/views/newCustomer/moneyDetails.vue'], resolve)
// // 绑定支付宝
// const  bindingzfb= resolve => require(['@/views/newCustomer/bindingzfb.vue'], resolve)
// // 已绑定支付宝
// const  bingdingedzfb= resolve => require(['@/views/newCustomer/bingdingedzfb.vue'], resolve)
//员工推广页
// const  empindex= resolve => require(['@/views/Employeeinvitations/empindex.vue'], resolve)
// //员工分享推广empInvitation
// const  empInvitation= resolve => require(['@/views/wxh5/empInvitation.vue'], resolve)


// // 地标
// const  dbindex= resolve => require(['@/views/dibiao/dbindex.vue'], resolve)
// //地标列表
// const  dblist= resolve => require(['@/views/dibiao/dblist.vue'], resolve)
// // 地标详情
//
// const  dbdetails= resolve => require(['@/views/dibiao/dbdetails.vue'], resolve)
// // 抽奖
// const  Luckdraw= resolve => require(['@/views/dibiao/Luckdraw.vue'], resolve)
// // 分享
// const  share= resolve => require(['@/views/wxh5/share.vue'], resolve)
// const  share1= resolve => require(['@/views/wxh5/share1.vue'], resolve)
// const  share2= resolve => require(['@/views/wxh5/share2.vue'], resolve)
// // 排行榜
// const  RankingList= resolve => require(['@/views/dibiao/RankingList.vue'], resolve)

var LOGIN_FLAG = true;
export default new Router({
  mode: 'history',
  base: 'ylh',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/index'
    },

    // {
    //   path: '/indexlist',
    //   name: 'indexlist',
    //   component: indexlist
    // },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    // {
    //   path: '/fx',
    //   name: 'fx',
    //   component: fx
    // },
    // {
    //   path: '/information',
    //   name: 'information',
    //   component: information
    // },
    // {
    //   path: '/Answer',
    //   name: 'Answer',
    //   component: Answer
    // },
    //   {
    //       path: '/Fraction',
    //       name: 'Fraction',
    //       component: Fraction
    //   },
      // {
      //     path: '/rankinglist',
      //     name: 'rankinglist',
      //     component: rankinglist
      // },
    // {
    //   path: '/fenx',
    //   name: 'fenx',
    //   component: fenx
    // },
    // {
    //   path: '/detailsone',
    //   name: 'detailsone',
    //   component: detailsone
    // },
    // {
    //   path: '/detailspeople',
    //   name: 'detailspeople',
    //   component: detailspeople
    // },
    // {
    //   path: '/yqindex',
    //   name: 'yqindex',
    //   component: yqindex
    // },
    // {
    //   path: '/yqnew',
    //   name: 'yqnew',
    //   component: yqnew
    // },
    // {
    //   path: '/yqpeople',
    //   name: 'yqpeople',
    //   component: yqpeople
    // },
    // {
    //   path: '/peoplelist1',
    //   name: 'peoplelist1',
    //   component: peoplelist1
    // },
    // {
    //   path: '/down',
    //   name: 'down',
    //   component: down
    // },
    // {
    //   path: '/Development',
    //   name: 'Development',
    //   component: Development
    // },
    // {
    //   path: '/redStatistics',
    //   name: 'redStatistics',
    //   component: redStatistics
    // },
    // {
    //   path: '/myReward',
    //   name: 'myReward',
    //   component: myReward
    // },
    // {
    //   path: '/outMoney',
    //   name: 'outMoney',
    //   component: outMoney
    // },
    // {
    //   path: '/rankingList',
    //   name: 'rankingList',
    //   component: rankingList
    // },
    // {
    //   path: '/moneyDetails',
    //   name: 'moneyDetails',
    //   component: moneyDetails
    // },
    // {
    //   path: '/Invitation',
    //   name: 'Invitation',
    //   component: Invitation
    // },
    // {
    //   path: '/bindingzfb',
    //   name: 'bindingzfb',
    //   component: bindingzfb
    // },
    // {
    //   path: '/bingdingedzfb',
    //   name: 'bingdingedzfb',
    //   component: bingdingedzfb
    // },
    // {
    //   path: '/dbindex',
    //   name: 'dbindex',
    //   component: dbindex
    // },
    // {
    //   path: '/dblist',
    //   name: 'dblist',
    //   component: dblist
    // },


    // {
    //   path: '/zfw',
    //   redirect: 'index',
    //   component: main,
    //   children: [{
    //     path: 'index',
    //     name: '首页',
    //     component: zfw,
    //     // meta: {
    //     // 	tabname: 'home',
    //     // 	keepAlive: true,
    //     // 	requireAuth: false,
    //     // 	allowBack: false
    //     // }
    //   }]
    //
    // },
  ],


})



// WEBPACK FOOTER //
// ./src/router/index.js